import { TreePine } from "lucide-react";

export function ElmGlyph({ className = "h-7 w-7" }) {
  return <TreePine className={className} strokeWidth={1.3} aria-hidden="true" />;
}

export default function ElmMark({ className = "", light = false }) {
  const tone = light ? "text-white/45" : "text-muted-foreground";
  return (
    <span className={`inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] ${tone} ${className}`} data-testid="elm-mark">
      <ElmGlyph className="h-5 w-5 shrink-0" />
      <span className="flex flex-col leading-tight"><span className="font-semibold">E.L.M</span><span className="text-[9px] tracking-[0.12em] opacity-70">Elevated Living Management</span></span>
    </span>
  );
}
